import { render } from "./OurInternetServicesReviews.vue?vue&type=template&id=692889e7&ts=true"
import script from "./OurInternetServicesReviews.vue?vue&type=script&lang=ts"
export * from "./OurInternetServicesReviews.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__